var React = require('react');

function ImagePolaroid (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 320H64V96h320z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 96v256h320V96zm64 32a32 32 0 1 1-32 32 32 32 0 0 1 32-32zM96 320l50.69-76a16 16 0 0 1 26.62 0l20.57 30.85 49.32-65.75a16 16 0 0 1 25.6 0L352 320z","className":"fa-primary","key":2})]);
}

ImagePolaroid.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ImagePolaroid;

ImagePolaroid.default = ImagePolaroid;
